import ResponsiveTitle from '@/components/molecules/responsiveTitle'
import Container from '@/components/templates/container'
import ImageBig from './imageBig'
import Description from './description'
import ImageSmall from './imageSmall'
import ButtonGroup from './buttonGroup'

const Facilities = ({ description, imageSmall, imageBig, ctaButton }) => {
  const base =
    'relative w-full grid grid-cols-1 lg:grid-cols-2 mt-largeMobile lg:mt-mediumDesktop gap-y-smallMobile lg:gap-x-[40px]'

  return (
    <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
      <ResponsiveTitle left="OUR" right="FACILITIES" />
      <div className={base}>
        <ImageBig image={imageBig} />
        <div className="relative w-full lg:min-h-screen flex flex-col justify-between">
          <div className="relative w-full">
            <Description description={description} />
            <ButtonGroup ctaButton={ctaButton} />
          </div>
          {imageSmall && <ImageSmall imageSmall={imageSmall} />}
        </div>
      </div>
    </Container>
  )
}

export default Facilities
